import { z } from 'zod'
import { oc } from '@orpc/contract'

export const batchRemoveOrgMembersInputSchema = z.object({
  practitionerIds: z.array(z.string().min(1)).min(1).max(100),
})

export const batchRemoveOrgMembersOutputSchema = z.object({
  succeeded: z.array(z.string()),
  failed: z.array(z.object({ practitionerId: z.string(), error: z.string() })),
  summary: z.object({
    total: z.number(),
    succeeded: z.number(),
    failed: z.number(),
  }),
})

export const batchRemoveOrgMembers = oc
  .route({ method: 'POST', path: '/v2/super/members/batch-remove' })
  .input(batchRemoveOrgMembersInputSchema)
  .output(batchRemoveOrgMembersOutputSchema)
